class FeaturedProductsMarquee {
    constructor(container) {
        this.container = container;
        this.wrapper = container.querySelector('.carousel-container');
        this.track = container.querySelector('[data-carousel-track]');
        this.items = Array.from(container.querySelectorAll('.carousel-item'));
        this.prevBtn = container.querySelector('.carousel-prev');
        this.nextBtn = container.querySelector('.carousel-next');
        
        if (!this.track || this.items.length === 0) return;

        this.scrollSpeed = 1;
        this.isHovered = false;
        this.isSmoothScrolling = false;
        this.animationId = null;

        this.init();
    }

    init() {
        for (let i = 0; i < 2; i++) {
            this.items.forEach(item => {
                const clone = item.cloneNode(true);
                clone.setAttribute('aria-hidden', 'true');
                this.track.appendChild(clone);
            });
        }

        this.wrapper.style.overflow = 'hidden';
        this.track.style.display = 'flex';
        this.track.style.width = 'max-content';
        this.track.classList.remove('marquee-active');
        
        if (window.matchMedia("(hover: hover)").matches) {
            this.wrapper.addEventListener('mouseenter', () => this.isHovered = true);
            this.wrapper.addEventListener('mouseleave', () => this.isHovered = false);
        }

        if (this.prevBtn) {
            this.prevBtn.addEventListener('click', () => {
                this.isSmoothScrolling = true;
                this.wrapper.scrollBy({ left: -300, behavior: 'smooth' });
                clearTimeout(this.scrollTimeout);
                this.scrollTimeout = setTimeout(() => this.isSmoothScrolling = false, 500);
            });
        }
        
        if (this.nextBtn) {
            this.nextBtn.addEventListener('click', () => {
                this.isSmoothScrolling = true;
                this.wrapper.scrollBy({ left: 300, behavior: 'smooth' });
                clearTimeout(this.scrollTimeout);
                this.scrollTimeout = setTimeout(() => this.isSmoothScrolling = false, 500);
            });
        }

        this.startScrolling();
    }

    startScrolling() {
        const loop = () => {
            if (!this.isHovered && !this.isSmoothScrolling) {
                this.wrapper.scrollLeft += this.scrollSpeed;
                
                const maxScrollLeft = this.track.scrollWidth - this.wrapper.clientWidth;
                if (this.wrapper.scrollLeft >= maxScrollLeft - 10) {
                    this.wrapper.scrollLeft = 0;
                }
            }
            this.animationId = requestAnimationFrame(loop);
        };
        this.animationId = requestAnimationFrame(loop);
    }
}

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-carousel-block]').forEach(block => {
        new FeaturedProductsMarquee(block);
    });
});